import { render, staticRenderFns } from "./DroppableItem.vue?vue&type=template&id=b7854e7e"
import script from "./DroppableItem.vue?vue&type=script&lang=js"
export * from "./DroppableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports